import {FC} from "react"
import {Block} from "./Block"
import {CoursePageProps} from "./CoursePageProps"

export const Depression: FC<Pick<CoursePageProps, "course">> = () => {
  return (
    <>
      <Block>
        <h1 className="mt-16">Welcome to Coping with Depression: Strategies for Healing and Recovery.</h1>
        <p>This program is designed for those experiencing
          mild to moderate clinical depression or sub-depressive states.
        </p>

        <p>Please note that <b>this program is not a substitute for medication or therapy</b>,
          but rather an additional tool to aid in your recovery.
        </p>

        <p>The program begins with a theoretical component that explores the development and
          impact of depression. From there, therapy sessions will focus on topics directly
          related to depression and strategies for managing symptoms. We will also work
          to establish or restore healthy habits, which are often a challenge for
          those struggling with depression.
        </p>

        <p>To accomplish this, we have developed a unique approach that combines coaching,
          meditation with guided imagery, and will continue using Zen Buddhist Big
          Mind technique you have learned in the Build Up program.
        </p>

        <p>Throughout the program, we will concentrate on developing the following
          healthy habits:
        </p>
        <ul className="list-rhombus">
          <li>Increasing physical activity</li>
          <li>Prioritizing restful sleep</li>
          <li>Building and maintaining supportive relationships</li>
          <li>Incorporating a healthy diet</li>
        </ul>
      </Block>

      <Block>
        <p>
          In addition to focusing on habit formation, we will also address the root causes
          and internal voices that contribute to depression. This will help individuals
          identify and overcome the underlying issues that may trigger or exacerbate symptoms.
        </p>
        <p>We believe that this program can help you in your journey towards healing and
          recovery from depression. We are here to support and guide you every step of the way.
        </p>
      </Block>
    </>
  )
}
